import styled from 'styled-components';

const HoverBox = styled.div`
  color: white;
  z-index: 100 !important;
  top: 140px;
  left: 0;
  position: fixed;
  background: white;
  width: 100%;
  height: 405px;
  margin-top: 20px;
`;

export default HoverBox;
